<template>
  <div style="padding: 0 10px;box-sizing: border-box;">
    <el-row :gutter="20" style="margin-top: 10px;margin-right:0;">
      <el-col :span="4">
        <div class="grid-content bg-purple">
          <el-tree :data="deptTree" node-key="id" default-expand-all :expand-on-click-node="false" @node-click="deptNodeClick">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span >{{ node.label }}</span>
              <span>
                <el-button type="text" size="mini"  @click="() => addChildDept(data)">添加</el-button>
                <el-button v-if="data.parentId != null && data.parentId != '' && data.parentId != '0'" type="text" size="mini"  @click="() => editDept(data)">编辑</el-button>
                <el-button v-if="data.parentId != null && data.parentId != '' && data.parentId != '0' && data.children.length == 0" type="text" size="mini"  @click="() => deleteDept(data)">删除</el-button>
              </span>
            </span>
        </el-tree>
        </div>
      </el-col>
      <el-col :span="20">
        <div class="grid-content bg-purple">
          <el-form :inline="true" size="small" :model="query" style="margin-top: 10px;">
            <el-form-item label="账户">
              <el-input v-model="query.userName" placeholder="账户" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号码">
              <el-input v-model="query.phoneNumber" placeholder="手机号码" clearable></el-input>
            </el-form-item>
            <el-form-item label="姓名">
              <el-input v-model="query.fullName" placeholder="姓名" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getUnitUserPage()"><i class="el-icon-search"></i> 查询</el-button>
              <el-button @click.native="showAddUnitUserDialog()"><i class="el-icon-plus"></i> 添加用户</el-button>
              <el-button >导入用户</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tableData" :header-cell-style="{fontSize: '14px', backgroundColor: '#f8f8f8',color:'#606266',height:'54px'}" border style="width: 100%" height="650px" stripe>
            <el-table-column label="类型" width="65" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-tag v-if="scope.row.hasAdmin == 1" size="small">管理</el-tag>
                <el-tag v-else type="info" size="small">普通</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="fullName" label="姓名" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="userName" label="账户名" width="170" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="phoneNumber" label="手机号" width="150" show-overflow-tooltip> </el-table-column> 
            <el-table-column prop="deptName" label="部门" width="160" show-overflow-tooltip> </el-table-column> 
            <el-table-column prop="email" label="电子邮箱" width="150" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="openId" label="微信标识" width="140" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="remarks" label="备注" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="kprq" label="已报销数量" width="130" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="160" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="ops" label="操作" fixed="right" width="140"> 
              <template slot-scope="scope">
                <el-button @click.native="showEditUnitUserDialog(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click.native="resetPassword(scope.row)" type="text" size="small">重置密码</el-button>
                <el-button @click="deleteUnitUserFunc(scope.row)" v-if="scope.row.hasAdmin == 0" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
        </el-table>
        <el-pagination style="float: right;margin-top: 10px;" :page-sizes="tablePage.pageSizeList" layout="sizes,prev,pager,next" @current-change="changePage" @size-change="changeSize" :total="tablePage.tableCount"></el-pagination>
        </div>
      </el-col>
    </el-row>
    <!-- <el-row style="height:600px;margin-top: -15px;">

      <el-col :span="5" style="padding: 10px;">
        <el-alert title="单位部门" type="info" :closable="false"></el-alert>
        <el-tree :data="deptTree" node-key="id" default-expand-all :expand-on-click-node="false" @node-click="deptNodeClick">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span >{{ node.label }}</span>
              <span>
                <el-button type="text" size="mini"  @click="() => addChildDept(data)">添加</el-button>
                <el-button v-if="data.parentId != null && data.parentId != '' && data.parentId != '0'" type="text" size="mini"  @click="() => editDept(data)">编辑</el-button>
                <el-button v-if="data.parentId != null && data.parentId != '' && data.parentId != '0' && data.children.length == 0" type="text" size="mini"  @click="() => deleteDept(data)">删除</el-button>
              </span>
            </span>
        </el-tree>
      </el-col>
      
      <el-col :span="19" style="padding: 10px;">
        <el-alert :title="currentDeptName" type="info" :closable="false"></el-alert>
        <el-form :inline="true" size="small" :model="query" style="margin-top: 10px;">
            <el-form-item label="账户">
              <el-input v-model="query.userName" placeholder="账户" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号码">
              <el-input v-model="query.phoneNumber" placeholder="手机号码" clearable></el-input>
            </el-form-item>
            <el-form-item label="姓名">
              <el-input v-model="query.fullName" placeholder="姓名" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getUnitUserPage()"><i class="el-icon-search"></i> 查询</el-button>
              <el-button @click.native="showAddUnitUserDialog()"><i class="el-icon-plus"></i> 添加用户</el-button>
              <el-button >导入用户</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tableData" style="width: 100%" height="650px" stripe>
            <el-table-column label="类型" width="65" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-tag v-if="scope.row.hasAdmin == 1" size="small">管理</el-tag>
                <el-tag v-else type="info" size="small">普通</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="fullName" label="姓名" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="userName" label="账户名" width="170" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="phoneNumber" label="手机号" width="150" show-overflow-tooltip> </el-table-column> 
            <el-table-column prop="deptName" label="部门" width="160" show-overflow-tooltip> </el-table-column> 
            <el-table-column prop="email" label="电子邮箱" width="150" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="openId" label="微信标识" width="120" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="remarks" label="备注" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="kprq" label="已报销数量" width="100" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="160" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="ops" label="操作" fixed="right" width="160"> 
              <template slot-scope="scope">
                <el-button @click.native="showEditUnitUserDialog(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click.native="resetPassword(scope.row)" type="text" size="small">重置密码</el-button>
                <el-button @click="deleteUnitUserFunc(scope.row)" v-if="scope.row.hasAdmin == 0" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
        </el-table>
        <el-pagination style="float: right;margin-top: 10px;" :page-sizes="tablePage.pageSizeList" layout="sizes,prev,pager,next" @current-change="changePage" @size-change="changeSize" :total="tablePage.tableCount"></el-pagination>   
      </el-col>  

    </el-row>   -->

    <!-- 编辑单位用户 -->
    <unit-user-dialog :unitUserInfo="unitUserInfo" :deptOptions="selectDeptOptions" :dialogVisible="userDialogVisible" @close="closeUserDialog"></unit-user-dialog>

  </div>
</template>

<script>
import { getInfo } from "@/cookie";
import { Message,MessageBox } from 'element-ui';
import { treeUnitDept,saveUnitDept,deleteUnitDept,listUnitDept } from "@/api/dept";
import { listUnitUser,saveUnitUser,deleteUnitUser,resetUnitSystemPassword } from "@/api/unitUser";

import UnitUserDialog from './dialog/UnitUserDialog.vue';

export default {
  name: "Configure",
  components: { UnitUserDialog },
  data() {
    return {

      query: {
        deptId: "",
        phoneNumber: "",
        fullName: "",
        tagList: []
      },
      tableData: [],
      tablePage : {
        pageNum: 1,
        pageSize: 10,
        tableCount: 50,
        pageSizeList: [10,20]
      },

      deptTree : [],
      deptList : [],
      currentDeptId: '',
      currentDeptName:'【-】用户',

      unitUserInfo : {
          id: '',
          deptId:'',
          fullName:'',
          userName:'',
          phoneNumber:'',
          email:'',
          remarks:'',
          isEdit:false,
      },
      userDialogVisible: false,
      selectDeptOptions: [],

    };
  },
  created() {
     let info_ = getInfo();
     this.userInfo = {...info_};
     this.getTreeDepts();
     this.getUnitUserPage();
     this.getListDeptInfos();
  },
  methods: {
    
    //获取数据
    getUnitUserPage(){
        let where = this.query;
            where.pageNum = this.tablePage.pageNum;
            where.pageSize = this.tablePage.pageSize;
        listUnitUser(where).then(res => {
            this.tableData = res.data.content;
            this.tablePage.tableCount = res.data.totalElements;
        });
    },
     //切换分页
    changePage(val1){
        this.tablePage.pageNum = val1;
        this.getUnitUserPage();
    },

    //切换分页
    changeSize(val) {
        this.tablePage.pageSize = val;
        this.getUnitUserPage();
    },

    //单位部门
    getTreeDepts(){
      treeUnitDept({}).then(res => {
          this.deptTree = res.data;
      });
    },
    //添加下级部门
    addChildDept(row){
        let parentId = row.id;
        let this_ = this;
        MessageBox.prompt('请输入下级部门名称', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputType: 'text',
            inputPlaceholder:'请输入下级部门名称',
            inputValidator: (val) => {
              if(val == '' || val == null){
                 return '部门名称不能为空';  
              }
            },
        }).then(({value}) => {
            saveUnitDept({parentId : parentId, deptName : value}).then(res => {
                if(res.code == 200){
                   Message.success('添加成功');
                   this_.getTreeDepts(); 
                   this_.getListDeptInfos();
                } else {
                   Message.error(res.msg);
                   return false;
                }
            });
        }).catch(() => {
                
        });
    },
    //编辑部门信息
    editDept(data) {
        let id = data.id;
        let deptName = data.label;
        let parentId = data.parentId;
        let this_ = this;
        MessageBox.prompt('请输入部门名称', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputType: 'text',
            inputValue: deptName,
            inputPlaceholder:'请输入部门名称',
            inputValidator: (val) => {
              if(val == '' || val == null){
                 return '部门名称不能为空';  
              }
            },
        }).then(({value}) => {
            saveUnitDept({id: id,parentId : parentId, deptName : value}).then(res => {
                if(res.code == 200){
                   Message.success('编辑成功');
                   this_.getTreeDepts(); 
                   this_.getListDeptInfos();
                } else {
                   Message.error(res.msg);
                   return false;
                }
            });
        }).catch(() => {
                
        });
    },
    //删除部门
    deleteDept(data){
      let this_ = this;
      MessageBox.confirm('是否确认删除该部门,确认后将不可撤销？', '确认信息', {
          distinguishCancelAndClose: true,
          confirmButtonText: '确认',
          cancelButtonText: '取消'
        }).then(() => {
          deleteUnitDept(data).then(res => {
              if(res.code == 200){
                 Message.success("删除成功"); 
                 this_.getTreeDepts();
                 this_.getListDeptInfos();
              } else {
                 Message.error(res.msg);
              }
          });
        }).catch(action => {
            
      });
    },
    //点击
    deptNodeClick(data) {
        this.query.deptId = data.id;
        this.currentDeptId = data.id;
        this.currentDeptName = "【" + data.label + "】用户";
        this.getUnitUserPage();
    },

    //获取部门选择下拉框
    getListDeptInfos(){
      listUnitDept({}).then(res => {
        this.selectDeptOptions = res.data;
      });
    },
    //重置信息
    resetUnitUserInfo(){
      this.unitUserInfo = {
          id: '',
          deptId:'',
          fullName:'',
          userName:'',
          phoneNumber:'',
          email:'',
          remarks:'',
          isEdit : false,
      }
    },
    //打开新增用户弹窗
    showAddUnitUserDialog(){
        this.resetUnitUserInfo();
        this.unitUserInfo.deptId = this.currentDeptId;
        this.userDialogVisible = true;
    },
    //打开编辑用户弹窗
    showEditUnitUserDialog(row){
        this.resetUnitUserInfo();
        this.unitUserInfo = {...row};
        this.unitUserInfo.isEdit = true;
        this.userDialogVisible = true;
    },
    //保存用户信息
    saveUnitUserFunc(){
      let this_ = this;
      this.$nextTick(() => {
        this_.$refs.unitUserForm.validate((valid) => {
            if(valid){
              let param = this_.unitUserInfo;
              if(param.deptId == null || param.deptId == ''){
                param.deptId = this_.currentDeptId;
              }
              this_.unitUserInfo.loading = true;
              saveUnitUser(param).then(res => {
                  this_.unitUserInfo.loading = false;
                  if(res.code == 200){
                    Message.success('保存成功'); 
                    this_.unitUserInfo.dialogFormVisible = false;
                    this_.getUnitUserPage();
                  } else {
                    Message.error(res.msg);
                  }
              });
            } 
        });
      });
    },
    //删除用户
    deleteUnitUserFunc(row){
      let this_ = this;
      MessageBox.confirm('此操作将永久删除该用户, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteUnitUser(row).then((res) => {
                if(res.code == 200){
                   Message.success('处理成功'); 
                   this_.getUnitUserPage();
                } else {
                   Message.error(res.msg);
                }
          });
        }).catch(() => {
                  
      });
    },
    //关闭用户弹窗
    closeUserDialog(){
      this.userDialogVisible = false;
      this.getUnitUserPage();
    },

    //重置用户密码
    resetPassword(row){
      let id = row.id;
      MessageBox.prompt('请输入重置后密码', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'password',
          inputValidator:(val) => {
              if(val == '' || val == null){
                  return '密码不能为空';
              }
          }
      }).then(({ value }) => {
        resetUnitSystemPassword({userId:id,password:value}).then(res => {
            if(res.code == 200){
               Message.success("操作成功"); 
            } else {
               Message.success(res.msg); 
            }
        });
      }).catch(() => {
               
      });
    },


  },
};
</script>


<style scoped>
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 8px;
    font-size: 15px;
    padding-right: 8px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .el-row {
    margin-bottom: 20px;
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
   border: 1px solid #f3f3f3;
   padding: 10px;
   box-sizing: border-box;
  }
  .bg-purple-light {
    /* background: #e5e9f2; */
  }
  .grid-content {
    border-radius: 4px;
    min-height: 770px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
</style>


// WEBPACK FOOTER //
// src/views/components/Configure.vue